import React from 'react';
import {InfoIcon} from '../../icons';
import {Form, Input} from 'antd';

export const LeadFiltrationField = () => {
  return (
    <Form.Item
      label={
        <span style={{display: 'flex', alignItems: 'center'}}>
          <span>Lead filtration search query:</span>
          <span style={{marginLeft: 5, cursor: 'pointer'}}>
            <InfoIcon message="Use this field to filter the audience" />
          </span>
        </span>
      }
    >
      <Input.TextArea />
    </Form.Item>
  )
}
